export default __webpack_public_path__ + "static/media/platform_logo.335df6d8.png";